<template>
    <div>
        <el-form label-position="right" label-width="90px">
            <el-row :gutter="20">
                <el-col :span="20">
                    <el-form-item label="日期">
                        <el-date-picker
                                v-model="date"
                                type="date"
                                :clearable="false"
                                style="width: 200px"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="20">
                    <el-form-item label="互换日期">
                        <el-date-picker
                            v-model="swap_date"
                            type="date"
                            :clearable="false"
                            style="width: 200px"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div style="text-align: right">
            <el-button @click="handleSwapDate()" :loading="$parentInfo.swapDate.button_loading">互换</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_SwapDate",
        data() {
            return {
                date:'',
                swap_date:''
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleSwapDate() {
                this.$parentInfo.swapDate.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'swap_date', {
                    'date': this.date,
                    'swap_date': this.swap_date,
                    'section_id': this.$parentInfo.filter.section_id,
                });
            },
        }
    }
</script>

<style scoped>

</style>